// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHOTO_FROM_USER_RATING = "Fotka z u\u017eivatelsk\u00e9 recenze";
